import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, Suspense } from "react";
import axios from "axios";
import userStore from "../../../../zustand/userStore";
import { apiKeyHeader } from "../../../../configs/ApiKeys";
import { WSLogDocumentClick } from "../../../../configs/WebService";
import { getDocumentsData } from "../redux/eventOrganiserThunks";
import { Typography, Box } from "@mui/material";
import { FileText, ArrowRight } from "lucide-react";
import { docCardTitle } from "../../../../OtherFunctions/docCardTitle";
import "./PropertyDocuments.css";

const PropertyDocuments = () => {
  const location = useLocation();
  const { state } = location || {};
  const { eventId, activityId } = state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { documentList = [] } = useSelector((store) => store.eventOrganiser);

  useEffect(() => {
    dispatch(
      getDocumentsData({
        type: "propertyDoc",
      }),
    );
  }, [dispatch]);

  const handleDocumentClick = async (doc) => {
    const userId = userStore.getState().user?.id;

    if (userId && Number(userId) > 0) {
      try {
        await axios.post(
          `${WSLogDocumentClick}?userId=${encodeURIComponent(userId)}`,
          {
            title: doc?.name_title || docCardTitle(doc),
            docFormId: doc?.id,
          },
          {
            headers: apiKeyHeader(),
          }
        );
      } catch (error) {
        console.error("Failed to log document click:", error);
      }
    }

    navigate("/docFormTestRunNew?formId=" + doc.id, {
      state: {
        nameTitle: doc?.name_title,
        eventId,
        activityId,
        languageId: doc.languageId,
      },
    });
  };
  return (
    <Suspense fallback={<>Loading...</>}>
      {/* {false && ( */}
      <div className="property-documents-container">
        {documentList.length === 0 ? (
          <Typography className="no-data">No Data Found</Typography>
        ) : (
          documentList.map((category) => (
            <Box key={category.categoryId} className="category-box">
              <div className="category-header">
                <Typography variant="h6" className="category-name">
                  {category.categoryName}
                </Typography>
                {/* {category.forms && category.forms.length > 5 && (
                  <button
                    className="view-all-btn"
                    onClick={() =>
                      navigate(`/documents/view-all/${category.categoryId}`)
                    }
                  >
                    View All
                    <ArrowRight />
                  </button>
                )} */}
              </div>
              {/* {category.forms.slice(0, 5).map((doc) => ( */}

              {category.forms && category.forms.length > 0 ? (
                <Box className="view-all-grid">
                  {category.forms.map((doc) => (
                    <div
                      key={doc.id}
                      className="document-item"
                      onClick={() => handleDocumentClick(doc)}
                    >
                      <div className="document-item-content">
                        <div className="document-icon">
                          <FileText />
                        </div>
                        <span className="document-title">
                          {docCardTitle(doc)}
                        </span>
                      </div>
                      <div className="document-arrow">
                        <ArrowRight />
                      </div>
                    </div>
                  ))}
                </Box>
              ) : (
                <Typography className="no-documents">
                  No documents available
                </Typography>
              )}
            </Box>
          ))
        )}
      </div>
      {/* )} */}
      {/* <PropertyDocumentsNew /> */}
    </Suspense>
  );
};

export default PropertyDocuments;
